import React from "react";
import Select from "react-select";
import { Field } from "formik";
import styles from "../../components/forms/forms.module.css";
import { tWithKeyAttr as t } from "../../i18nHelper";
import { TCompanySize, TSector, TLanguage } from "../../types/types";
import {
  useGetCompanySizesQuery,
  useGetSectorsQuery,
} from "../../services/api/onboarding.api";
import { useGetLanguagesQuery } from "../../services/api/language.api";
import i18n from "../../i18n";

interface CompanyInfoStepProps {
  values: any;
  setFieldValue: (field: string, value: any) => void;
  errors: any;
  touched: any;
}

const CompanyInfoStep: React.FC<CompanyInfoStepProps> = ({
  values,
  setFieldValue,
  errors,
  touched,
}) => {
  const { 
    data: companySizes, 
    isLoading: isLoadingCompanySizes, 
    isError: isErrorCompanySizes 
  } = useGetCompanySizesQuery();
  
  const { 
    data: sectors, 
    isLoading: isLoadingSectors, 
    isError: isErrorSectors 
  } = useGetSectorsQuery();
  
  const { 
    data: languages, 
    isLoading: isLoadingLanguages, 
    isError: isErrorLanguages 
  } = useGetLanguagesQuery();

  return (
    <ul className={`${styles.form__list} ${styles.form__list_type_oneColumn}`}>
      <li>
        <label className={styles.form__label}>{t("ONBOARDING_COMPANY_SIZE")}</label>
        <Select
          name="companySizeId"
          value={companySizes?.find((c: TCompanySize) => c.id == values.companySizeId) ? {
            value: values.companySizeId,
            label: `${companySizes.find((c: TCompanySize) => c.id == values.companySizeId)?.min}-${companySizes.find((c: TCompanySize) => c.id == values.companySizeId)?.max}`,
            id: values.companySizeId
          } : null}
          onChange={(option: any) => setFieldValue("companySizeId", option?.value || "")}
          options={companySizes?.map((c: TCompanySize) => ({
            value: c.id,
            label: `${c.min}-${c.max}`,
            id: c.id
          })) || []}
          placeholder={isErrorCompanySizes ? t("ERROR_LOADING_DATA") : t("ONBOARDING_SELECT")}
          isClearable
          isLoading={isLoadingCompanySizes}
          isDisabled={isErrorCompanySizes}
          className="react-select-container"
          classNamePrefix="react-select"
        />
        {errors?.companySizeId && touched?.companySizeId && <p className="error">{t(errors.companySizeId)}</p>}
        {isErrorCompanySizes && <p className="error">{t("ERROR_LOADING_COMPANY_SIZES")}</p>}
      </li>

      <li>
        <label className={styles.form__label}>{t("ONBOARDING_SECTOR")}</label>
        <Select
          name="sectorId"
          value={sectors?.find((s: TSector) => s.id == values.sectorId) ? {
            value: values.sectorId,
            label: sectors.find((s: TSector) => s.id == values.sectorId)?.name,
            id: values.sectorId
          } : null}
          onChange={(option: any) => setFieldValue("sectorId", option?.value || "")}
          options={sectors?.map((s: TSector) => ({
            value: s.id,
            label: s.name,
            id: s.id
          })) || []}
          placeholder={isErrorSectors ? t("ERROR_LOADING_DATA") : t("ONBOARDING_SELECT")}
          isClearable
          isLoading={isLoadingSectors}
          isDisabled={isErrorSectors}
          className="react-select-container"
          classNamePrefix="react-select"
        />
        {errors?.sectorId && touched?.sectorId && <p className="error">{t(errors.sectorId)}</p>}
        {isErrorSectors && <p className="error">{t("ERROR_LOADING_SECTORS")}</p>}
      </li>

      <li>
        <label className={styles.form__label}>{t("ONBOARDING_PREFERRED_LANGUAGE")}</label>
        <Select
          name="prefferedLanguageId"
          value={languages?.find((l: TLanguage) => l.id == values.prefferedLanguageId) ? {
            value: values.prefferedLanguageId,
            label: languages.find((l: TLanguage) => l.id == values.prefferedLanguageId)?.name,
            id: values.prefferedLanguageId
          } : null}
          onChange={(option: any) => setFieldValue("prefferedLanguageId", option?.value || "")}
          options={languages?.map((l: TLanguage) => ({
            value: l.id,
            label: l.name,
            id: l.id
          })) || []}
          placeholder={isErrorLanguages ? t("ERROR_LOADING_DATA") : t("ONBOARDING_SELECT")}
          isClearable
          isLoading={isLoadingLanguages}
          isDisabled={isErrorLanguages}
          className="react-select-container"
          classNamePrefix="react-select"
        />
        {errors?.prefferedLanguageId && touched?.prefferedLanguageId && <p className="error">{t(errors.prefferedLanguageId)}</p>}
        {isErrorLanguages && <p className="error">{t("ERROR_LOADING_LANGUAGES")}</p>}
      </li>

      <li className={styles.liWide}>
        <label className={styles.form__label}>{t("ONBOARDING_USAGE_PURPOSE")}</label>
        <Field
          as="textarea"
          name="target_use_case"
          placeholder={t("ONBOARDING_WHY_JOIN_APP")}
          className={`${styles.form__input} ${styles.form__textArea}`}
        />
      </li>
    </ul>
  );
};

export default CompanyInfoStep;

